import { encodeEscPosChars } from './escposCharset';

/**
 * QR nativo ESC/POS `GS ( k` (Epson TM, Xprinter y térmicas 58/80mm genéricas).
 */
export function escposQrBlock(url: string): number[] {
  const data = encodeEscPosChars(url);
  const storeLen = data.length + 3;
  const pL = storeLen & 0xff;
  const pH = (storeLen >> 8) & 0xff;
  return [
    0x1b, 0x61, 0x01,
    0x1d, 0x28, 0x6b, 0x04, 0x00, 0x31, 0x41, 0x32, 0x00,
    0x1d, 0x28, 0x6b, 0x03, 0x00, 0x31, 0x43, 0x06,
    0x1d, 0x28, 0x6b, 0x03, 0x00, 0x31, 0x45, 0x31,
    0x1d, 0x28, 0x6b, pL, pH, 0x31, 0x50, 0x30, ...data,
    0x1d, 0x28, 0x6b, 0x03, 0x00, 0x31, 0x51, 0x30,
    0x1b, 0x61, 0x00, 0x0a,
  ];
}

/** Label corto bajo el QR en ticket de venta (58mm). */
export const SALE_TRACKING_QR_LABEL = 'Escaneá para ver cuándo está listo.';
